import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';

export function useTenantNav() {
  const navigate = useNavigate();
  const { currentTenant } = useTenant();
  const base = currentTenant?.slug ? `/${currentTenant.slug}` : '';

  const tenantNavigate = useCallback(
    (path: string, options?: { replace?: boolean; state?: any }) => {
      // If path already starts with the base, don't double-prefix
      const fullPath = path.startsWith(base) ? path : `${base}${path}`;
      navigate(fullPath, options);
    },
    [navigate, base],
  );

  return { navigate: tenantNavigate, base };
}
